import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const style = () => {
  const { space6, space8 } = theme();

  return StyleSheet.create({
    content: {
      marginBottom: space8,
    },
    title: {
      marginBottom: space6,
    },
  });
};

export { style };
